import PropTypes from 'prop-types';

export const cartDataProps = PropTypes.shape({
  duration: PropTypes.string.isRequired,
  currency: PropTypes.string.isRequired,
  monthlyTotal: PropTypes.number.isRequired,
  yearlyTotal: PropTypes.number.isRequired,
  recurringAmount: PropTypes.number.isRequired,
  billedToday: PropTypes.number.isRequired
});

export const trialInfoProps = PropTypes.shape({
  trialLength: PropTypes.number
});

export const isTrialProps = PropTypes.bool;

export const analyticsDataProps = PropTypes.shape({
  origin: PropTypes.string,
  platform: PropTypes.string
});

export default {
  cartDataProps,
  trialInfoProps,
  isTrialProps,
  analyticsDataProps
};
